// extracted by mini-css-extract-plugin
export default {"searchCategory":"FormCategory_searchCategory__bQ3Po","form":"FormCategory_form__SxKj8","divInput":"FormCategory_divInput__X62u6"};